import appleLogo from "@/assets/images/apple-icon.png";
import googleLogo from "@/assets/images/google-icon.png";
import phantomLogo from "@/assets/images/phantom-icon.png";
import soflareLogo from "@/assets/images/solflare-icon.png";
import twitterLogo from "@/assets/images/twitter-icon.png";
import useAccounts from "@/hooks/useAccounts";
import { LogoSocial } from "@/pages/PreSalePage/FormContribute.styled";
import {
  AuthContext,
  SocialLogin,
  WalletLogin,
} from "@/providers/AuthProvider";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { CircularProgress } from "@mui/material";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import { useWallet } from "@solana/wallet-adapter-react";
import {
  BitgetWalletName,
  PhantomWalletName,
  SolflareWalletName,
} from "@solana/wallet-adapter-wallets";
import { useContext, useEffect, useState } from "react";
import {
  WalletAmountBox,
  WalletAmountContinue,
  WrapInputContinue,
} from "./ConnectWallet.styled";
export default function ConnectWallet({
  openLoginModal,
  setOpenLoginModal,
}: {
  openLoginModal: boolean;
  setOpenLoginModal: (b: boolean) => void;
}) {
  const { login, loading } = useContext(AuthContext);
  const { address } = useAccounts();
  const { select } = useWallet();

  // const [openLoginModal, setOpenLoginModal] = useState(false);
  const [openLoginModalWallet, setOpenLoginModalWallet] = useState(false);

  type Anchor = "top" | "left" | "bottom" | "right";
  const toggleDrawer =
    (anchor: Anchor, open: boolean, type: string) =>
    (event: React.KeyboardEvent | React.MouseEvent) => {
      if (
        event &&
        event.type === "keydown" &&
        ((event as React.KeyboardEvent).key === "Tab" ||
          (event as React.KeyboardEvent).key === "Shift")
      ) {
        return;
      }
      if (type == "social") {
        setOpenLoginModal(open);
      } else {
        setOpenLoginModalWallet(open);
      }
    };

  useEffect(() => {
    if (address && openLoginModalWallet) {
      setOpenLoginModalWallet(false);
    }
  }, [address]);
  return (
    <div>
      {/* <Button onClick={() => setOpenLoginModal(true)}>Login</Button> */}
      <SwipeableDrawer
        anchor={"bottom"}
        open={openLoginModal}
        onClose={toggleDrawer("bottom", false, "social")}
        onOpen={toggleDrawer("bottom", true, "social")}
        className="modal-login-web3"
      >
        <div
          className="modal-container-wrapper"
          style={{ maxWidth: 800, margin: "0 auto", width: "100%" }}
        >
          <p className="title-modal" style={{ marginBottom: "20px" }}>
            Log in or Sign Up
          </p>
          <div className="logo-modal">
            <p className="sub-title-modal">MANEKO</p>
          </div>
          <WalletAmountBox
            sx={{ mb: "16px" }}
            disabled={loading.google}
            onClick={() => {
              login({ tSocial: SocialLogin.GOOGLE });
            }}
          >
            <LogoSocial src={googleLogo} alt="Logo" />
            {loading.google ? (
              <CircularProgress color="inherit" size={24} />
            ) : (
              "Google"
            )}
          </WalletAmountBox>
          <WalletAmountBox
            disabled={loading.twitter}
            onClick={() => {
              login({ tSocial: SocialLogin.TWITTER });
            }}
            sx={{ mb: "16px" }}
          >
            <LogoSocial src={twitterLogo} alt="Logo" />
            {loading.twitter ? (
              <CircularProgress color="inherit" size={24} />
            ) : (
              "Twitter"
            )}
          </WalletAmountBox>
          <WalletAmountBox
            disabled={loading.apple}
            onClick={() => {
              login({ tSocial: SocialLogin.APPLE });
            }}
            sx={{ mb: "16px" }}
          >
            <LogoSocial src={appleLogo} alt="Logo" />
            {loading.apple ? (
              <CircularProgress color="inherit" size={24} />
            ) : (
              "Apple"
            )}
          </WalletAmountBox>
          <WalletAmountContinue
            sx={{ mb: "16px" }}
            onClick={() => {
              setOpenLoginModal(false);
              setOpenLoginModalWallet(true);
            }}
          >
            <WrapInputContinue>
              <LogoSocial src="/assets/wallet-icon.png" alt="Logo" />
              <p className="continue-wallet">Continue with a wallet</p>
            </WrapInputContinue>
          </WalletAmountContinue>
        </div>
      </SwipeableDrawer>
      <SwipeableDrawer
        anchor={"bottom"}
        open={openLoginModalWallet}
        onClose={toggleDrawer("bottom", false, "wallet")}
        onOpen={toggleDrawer("bottom", true, "wallet")}
        className="modal-login-web3"
      >
        <div className="modal-container-wrapper">
          <div className="wrapper-modal-wallet">
            <div
              className="wallet-modal-back"
              onClick={() => {
                setOpenLoginModal(true);
                setOpenLoginModalWallet(false);
              }}
            >
              <ArrowBackIcon />
            </div>
            <p className="title-modal">Log in or Sign Up</p>
          </div>

          <WalletAmountBox
            sx={{ mb: "16px" }}
            disabled={loading.solflare}
            onClick={() => {
              select(SolflareWalletName);
              login({ tWallet: WalletLogin.SOLFLARE });
            }}
          >
            <LogoSocial src={soflareLogo} alt="Logo" />
            {loading.solflare ? (
              <CircularProgress color="inherit" size={24} />
            ) : (
              "Solflare Wallet"
            )}
          </WalletAmountBox>
          <WalletAmountBox
            disabled={loading.phantom}
            onClick={() => {
              select(PhantomWalletName);
              login({ tWallet: WalletLogin.PHANTOM });
            }}
            sx={{ mb: "16px" }}
          >
            <LogoSocial src={phantomLogo} alt="Logo" />
            {loading.phantom ? (
              <CircularProgress color="inherit" size={24} />
            ) : (
              "Phantom Wallet"
            )}
          </WalletAmountBox>
          <WalletAmountBox
            disabled={loading.bitget}
            onClick={() => {
              select(BitgetWalletName);
              login({ tWallet: WalletLogin.BITGET });
            }}
            sx={{ mb: "16px" }}
          >
            <LogoSocial
              src="/assets/bitget-icon.png"
              style={{
                borderRadius: "1000px",
              }}
              alt="Logo"
            />
            {loading.bitget ? (
              <CircularProgress color="inherit" size={24} />
            ) : (
              "Bitget Wallet"
            )}
          </WalletAmountBox>
          <WalletAmountBox
            // disabled={loading.bitget}
            onClick={async () => {
              const gateProvider = window?.gatewallet?.solana;
              if (gateProvider) {
                const resp = await gateProvider.connect();
                console.log(resp.publicKey.toString());
              }
              // select(BitgetWalletName);
              // login({ tWallet: WalletLogin.BITGET });
            }}
            sx={{ mb: "16px" }}
          >
            <LogoSocial
              src="/assets/gate-logo.png"
              style={{
                borderRadius: "1000px",
              }}
              alt="Logo"
            />
            Gate Wallet
          </WalletAmountBox>
        </div>
      </SwipeableDrawer>
    </div>
  );
}
